import { render, staticRenderFns } from "./OrderCardWebsite.vue?vue&type=template&id=0ce68d08&scoped=true&"
import script from "./OrderCardWebsite.vue?vue&type=script&lang=js&"
export * from "./OrderCardWebsite.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardWebsite.vue?vue&type=style&index=0&id=0ce68d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce68d08",
  null
  
)

export default component.exports